export function chainMultiplier(chain, scoring) {
    const multipliers = scoring.chainMultipliers;
    const index = Math.min(Math.max(chain, 1), multipliers.length) - 1;
    return multipliers[index] ?? 1;
}
/**
 * Очки за один шаг цепочки:
 * (вирусы × virusPoints + сегменты × segmentPoints + плёнки × shieldPoints) × множитель шага.
 */
export function scoreClear(input, scoring) {
    const base = input.viruses * scoring.virusPoints +
        input.segments * scoring.segmentPoints +
        (input.shields ?? 0) * scoring.shieldPoints;
    return base * chainMultiplier(input.chain, scoring);
}
//# sourceMappingURL=scoring-system.js.map